// @ts-nocheck
const DEFAULT_TEAM_FIELDS = [
  {
    "name": "Team Name",
    "fieldId": "teamName",
    "required": true,
    "helperText": "",
    "include": true,
    "fieldType": "textbox",
    "primitiveType": "string",
    "error": {
      "name": "",
      "helperText": ""
    },
    "options": []
  },
  {
    name: "Event",
    fieldId: "requestedContest",
    required: true,
    helperText: "",
    include: true,
    fieldType: "select",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Division",
    fieldId: "requestedDivision",
    required: true,
    helperText: "",
    include: true,
    fieldType: "select",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  }
]

const DEFAULT_MANAGER_FIELDS = [
  {
    name: "First Name",
    fieldId: "first_name",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Last Name",
    fieldId: "last_name",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Email",
    fieldId: "email",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Phone",
    fieldId: "phone",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Title",
    fieldId: "title",
    required: true,
    helperText: "Coach, Assistant Coach, Manager, etc",
    include: false,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  }
]

export { DEFAULT_TEAM_FIELDS, DEFAULT_MANAGER_FIELDS };
